import { Icon } from '@vds/icons';
import styled, { keyframes } from 'styled-components';

export const HeaderButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  width: ${(props) => props.width || 'fit-content'};
  height: 44px;
  min-height: 44px;
  border: 1px solid rgba(0, 0, 0, 1);
  border-radius: 9999px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border: 1px solid #000000;
    box-shadow: inset 0 0 0 1px #000000;
  }

  @media (max-width: 767px) {
    height: 44px;
    width: 44px;
    border-radius: 50%;
    padding: 12px;
    border: 1px solid #DDDAD4;
  }
`;

export const SuggestedButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  width: ${(props) => props.width || 'fit-content'};
  height: 44px;
  min-height: 44px;
  border: 1px solid rgba(0, 0, 0, 1);
  border-radius: 9999px;
  background: white;
  color: #000000;
  -webkit-text-fill-color: #000000;
  box-sizing: border-box;
  cursor: pointer;
  transition:
    opacity 420ms cubic-bezier(0.22, 1, 0.36, 1),
    transform 420ms cubic-bezier(0.22, 1, 0.36, 1),
    border-width 160ms ease;

  &:hover {
    border: 1px solid #000000;
    box-shadow: inset 0 0 0 1px #000000;
  }

  &:disabled {
    opacity: 0.17;
    color: #000;
    -webkit-text-fill-color: #000000;
    background: #ffffff;
    border-color: #000;
    box-shadow: none;
    transform: none;
    cursor: not-allowed;
    pointer-events: none;
  }

  @media (max-width: 767px) {
    height: fit-content;
    padding: 8px 16px;
    // max-height: 32px;
    min-height: 32px;
  }
`;

export const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 50%;
  justify-content: flex-end;
`;

export const SegmentedToggle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(51, 51, 50, 0.50);
  border-radius: 50px;
  padding: 3px;
  width: 80px;
  height: 40px;
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  border: 1px solid rgba(0, 0, 0, 0.2);

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 3px solid #000000;
    outline-offset: 2px;
  }
`;


export const ToggleContentTransition = styled.div`
  opacity: ${(props) => (props.$phase === 'entered' ? 1 : 0)};
  transition:
    opacity 520ms cubic-bezier(0.22, 1, 0.36, 1),
    transform 620ms cubic-bezier(0.22, 1, 0.36, 1);

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const ToggleSlider = styled.div`
  position: absolute;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: white;
  // box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  box-shadow: 0 var(--vds-shadow-y-2, 2px) var(--vds-shadow-blur-4, 4px) 0 var(--vds-shadow-opacity-32, rgba(0, 0, 0, 0.32)), 0 var(--vds-shadow-y-1, 1px) var(--vds-shadow-blur-10, 10px) 0 var(--vds-shadow-opacity-24, rgba(0, 0, 0, 0.24));
  transition: transform 0.25s ease;
  left: ${(props) => (props.active ? '47.5%' : '52.5%')};
  top: 50%;
  transform: ${(props) =>
    props.active
      ? 'translate(calc(-50% - 18px), -50%)'
      : 'translate(calc(-50% + 18px), -50%)'};
`;

export const ToggleSegment = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  position: relative;
  z-index: 1;
  flex-shrink: 0;
`;

const generatingPulse = keyframes`
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
`;

const responseEnter = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-12px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const GeneratingRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  max-width: 976px;
  padding-top: 16px;
`;

export const GeneratingLabel = styled.div`
  color: #808080;
  animation: ${generatingPulse} 1.3s ease-in-out infinite;
`;

export const ResponseContent = styled.div`
  max-width: 1024px;
  padding-top: 16px;
  padding-bottom:16px;
  animation: ${responseEnter} 3.6s cubic-bezier(0.16, 1, 0.3, 1);
`;

export const IconButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: rgba(170, 168, 163, 0.12);
  padding: 8px;
  box-sizing: border-box;
  border-radius: 50%;
  cursor: pointer;
`;

export const IconActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: rgba(170, 168, 163, 0.12);
  padding: 8px;
  box-sizing: border-box;
  border-radius: 50%;
  border: none;
  cursor: pointer;

  &:focus-visible {
    outline: 3px solid #000000;
    outline-offset: 2px;
  }
`;

export const PillWrapper = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  cursor: pointer;

  @media (max-width: 1023px) {
    position: static;
  }
`;

export const PillChip = styled.span`
  display: inline-flex;
  align-items: center;
  width: fit-content;
  margin-left: 8px;
  border: none;
  border-radius: 4px;
  background: rgba(221, 218, 212, 1);
  color: rgba(0, 0, 0, 1);
  padding: 3px 4px;
  font: inherit;
  text-align: left;
  appearance: none;
  transition: background 0.15s ease;

  @media (min-width: 1024px) {
    ${PillWrapper}:hover & {
      background: rgba(195, 191, 183, 1);
    }
  }

  @media (max-width: 1023px) {
    cursor: pointer;
  }
`;

export const PillDropdown = styled.div`
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  padding-top: 8px;
  z-index: 200;
  width: 311px;
  box-sizing: border-box;

  @media (min-width: 1024px) {
    ${PillWrapper}:hover & {
      display: block;
    }
  }

  @media (max-width: 1023px) {
    width: calc(100vw - 40px);
    max-width: 311px;
    left: 50%;
    right: auto;
    transform: translateX(-50%);
  }
`;

export const PillDropdownInner = styled.div`
  position: relative;
  background: #ffffff;
  border: 1px solid rgba(170, 168, 163, 0.4);
  border-radius: 12px;
  box-shadow: 0 1px 20px rgba(0, 0, 0, 0.08);
  width: 100%;
  height: 204px;
  box-sizing: border-box;
  overflow: hidden;
`;

export const PillDropdownScrollArea = styled.div`
  height: 100%;
  padding-right: 18px;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  @media (max-width: 1023px) {
    padding-right: 0px;
  }
`;

export const PillScrollbarTrack = styled.div`
  position: absolute;
  top: 8px;
  bottom: 8px;
  right: 6px;
  width: 4px;
  pointer-events: none;
`;

export const PillScrollbarThumb = styled.div`
  position: absolute;
  left: 0;
  width: 100%;
  border-radius: 999px;
  background: rgba(128, 128, 128, 0.9);
`;

export const PillDropdownItem = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 4px;
  margin: 0 16px;
  margin-right: 6px;
  padding: 16px 0;
  cursor: pointer;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(170, 168, 163, 0.4);

  @media (max-width: 1023px) {
    flex-direction: row;
    gap: 12px;
    margin: 0; 
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const PillDropdownThumb = styled.img`
  display: none;
  width: 68px;
  height: 68px;
  object-fit: cover;
  border-radius: 8px;
  flex-shrink: 0;

  @media (max-width: 1023px) {
    display: block;
  }
`;

export const PillDropdownText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;

  a {
    color: rgba(0, 0, 0, 1);
  }
`;

export const PillDropdownLabel = styled.div`
  color: rgba(113, 111, 109, 1);
`;

export const HighlightBlock = styled.span`
  display: inline;
  box-decoration-break: clone;
  -webkit-box-decoration-break: clone;
  transition: background 0.15s ease;

  @media (max-width: 1023px) {
    position: relative;
    display: block;
    width: 100%;
  }

  @media (min-width: 1024px) {
    &:hover {
      background: rgba(172, 204, 252, 0.9);
    }

    &:hover ${PillChip} {
      background: rgba(172, 204, 252, 0.9);
    }

    &:hover ${PillDropdown} {
      display: block;
    }
  }
`;

export const PillModalDropdownBody = styled.div`
  position: relative;
  height: 316px;
  box-sizing: border-box;
  overflow: hidden;

  @media (max-width: 767px) {
    height: calc(100vh - 112px);
  }
`;

export const SourcesAccordionButton = styled.button`
  width: fit-content;
  border: none;
  border-radius: 0;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  padding: 0;
  cursor: pointer;
  text-align: left;
  color: #111111;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 3px solid #000000;
    outline-offset: 2px;
  }
`;

const SourcesChevronBase = ({ className, open, ...props }) => (
  <span className={className}>
    <Icon {...props} />
  </span>
);

export const SourcesChevron = styled(SourcesChevronBase)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: ${(props) => (props.open ? 'rotate(180deg)' : 'rotate(0deg)')};
  transform-origin: center center;
  flex-shrink: 0;
  transition: transform 0.2s ease;
`;

const slideDown = keyframes`
  from {
    opacity: 0;
    max-height: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    max-height: 2000px;
    transform: translateY(0);
  }
`;

const slideUp = keyframes`
  from {
    opacity: 1;
    max-height: 2000px;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    max-height: 0;
    transform: translateY(-8px);
  }
`;

export const SourcesPanel = styled.div`
  padding: 16px 0;
  background: transparent;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  animation: ${(props) => (props.$isClosing ? slideUp : slideDown)} 0.25s ease
    forwards;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const AskAICtaCard = styled.div`
  width: 100%;
  max-width: 976px;
  border: 1px solid rgba(170, 168, 163, 0.4);
  border-radius: 16px;
  background: rgba(255, 255, 255, 1);
  padding: 32px;
  box-sizing: border-box;

  @media (max-width: 767px) {
    padding: 20px 16px;
  }
`;

export const AskAICtaButtonRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
  flex-wrap: wrap;
`;

export const AskAICtaPrimaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  height: 44px;
  padding: 12px 24px;
  border: 1px solid rgba(0, 0, 0, 1);
  border-radius: 9999px;
  background: rgba(0, 0, 0, 1);
  color: rgba(255, 255, 255, 1);
  cursor: pointer;
  transform: translateZ(0);
  will-change: transform, opacity;
  transition:
    opacity 260ms cubic-bezier(0.22, 1, 0.36, 1),
    transform 260ms cubic-bezier(0.22, 1, 0.36, 1);

  &:hover {
    // opacity: 0.88;
    transform: translateZ(0) scale(1.03);
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const AskAICtaSecondaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 12px 24px;
  border: 1px solid rgba(0, 0, 0, 1);
  border-radius: 9999px;
  background: rgba(255, 255, 255, 1);
  color: rgba(0, 0, 0, 1);
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    // background: rgba(242, 242, 242, 1);
    border: 1px solid #000000;
    box-shadow: inset 0 0 0 1px #000000;
  }

  @media (max-width: 767px) {
    // min-height: 32px;
    // padding: 8px 16px;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;

  @media (max-width: 767px) {
    padding: 0;
    align-items: flex-end;
  }
`;

export const ModalCard = styled.div`
  position: relative;
  background: #ffffff;
  border-radius: 32px;
  padding: 48px;
  width: 100%;
  max-width: 592px;
  box-sizing: border-box;
  box-shadow: 0 4px 40px rgba(0, 0, 0, 0.16);

  @media (max-width: 767px) {
    max-width: 100%;
    width: 100%;
    min-height: 100vh;
    border-radius: 0;
    padding: 16px;
    padding-top: 44px;
  }
`;

export const ModalCloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  color: #000;

&:focus {
  outline: none;
}

&:focus-visible {
  outline: 3px solid #000000;
  outline-offset: 2px;
  border-radius: 6px;
}
  @media (max-width: 767px) {
    top: 12px;
    height: 20px;
    width: 20px;
  }
`;

export const ModalButtonRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 48px;
  flex-wrap: wrap;

  & > button {
    width: 48%;
    justify-content: center;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    margin-top: 32px;

    & > button {
      width: 100%;
      justify-content: center;
    }
  }
`;

export const ChatThread = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const UserQueryRow = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 32px 24px 0;

  @media (max-width: 767px) {
    padding: 24px 16px 0;
  }
`;

export const UserQueryBubble = styled.div`
  max-width: 70%;
  background: #f0f0f0;
  border-radius: 20px 20px 4px 20px;
  padding: 12px 20px;
  box-sizing: border-box;

  @media (max-width: 767px) {
    max-width: 85%;
  }
`;

export const AIResponseEntry = styled.div`
  max-width: 1024px;
  padding-top: 24px;
`;

export const StreamingCursor = styled.span`
  display: inline-block;
  width: 2px;
  height: 1em;
  background: currentColor;
  margin-left: 2px;
  vertical-align: text-bottom;
  animation: blink 0.8s step-end infinite;

  @keyframes blink {
    0%, 100% { opacity: 1; }
    50% { opacity: 0; }
  }
`;
